/**
 * Codici di stato dei servizi ADM, dalle tabelle dei manuali operativi (annuale §8,
 * semestrale §7). Il `process` risponde 20 all'acquisizione; lo stato poi evolve e si
 * interroga con lo IUT (InteropRService, `selezionaStato`).
 */
const ETICHETTE: Record<string, string> = {
  '0': 'Servizio non disponibile',
  '1': 'La verifica della firma è fallita',
  '2': 'Il certificato utilizzato per la firma non è valido',
  '3': "L'Autorità di certificazione non è ritenuta sicura",
  '4': "La verifica dell'integrità del messaggio è fallita",
  '5': 'Messaggio non firmato',
  '6': 'Dimensione massima del file superata',
  '7': 'CA verifica certificato: fallita',
  '9': 'Service ID non esistente',
  '10': 'Verifica xsd: fallita',
  '12': 'Richiesta non ancora elaborata',
  '13': 'Condizioni xsd violate',
  '14': 'Utente non autorizzato',
  '15': 'Dati di input non validi',
  '16': 'Certificato autenticazione non valido',
  '18': 'Firmatario non autorizzato',
  '20': 'Acquisito a sistema',
  '50': 'In elaborazione',
  '51': 'In elaborazione: controllo sostanziale superato',
  '197': 'Elaborazione KO: senza esito',
  '198': 'Elaborazione KO: con esito',
  '199': 'Elaborazione OK: completata senza esito finale',
  '200': 'Elaborazione OK: completata con esito finale',
}

const IN_CORSO = new Set(['12', '20', '50', '51'])
const OK = new Set(['199', '200'])

export type ClasseStatoAdm = 'in_corso' | 'ok' | 'ko'

/** Tutto cio' che non e' in corso ne' concluso bene e' un rifiuto: un codice nuovo
 * non deve lasciare una dichiarazione «inviata» che le Dogane hanno scartato. */
export function classificaStatoAdm(codice: string): ClasseStatoAdm {
  if (IN_CORSO.has(codice)) return 'in_corso'
  if (OK.has(codice)) return 'ok'
  return 'ko'
}

export function etichettaStatoAdm(codice: string): string {
  return ETICHETTE[codice] ?? `Codice ${codice}`
}
